<template>
  <div class="contact">
    <formContact />
  </div>
</template>

<script>
import formContact from "../components/Contact/formConntact";
export default {
  components: {
    formContact,
  },
  created(){
    document.title = "OverLab | Contáctenos"
  }
};
</script>

<style lang="css" scoped>
.contact{
  margin-top: 100px;
}
@media (max-width: 995px) {
  .contact {
    margin-top: 0;
  }
}
</style>
